var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sparkle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 2L11.8 6.8L16 8L11.8 9.2L10 14L8.2 9.2L4 8L8.2 6.8L10 2Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.8,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.5 1.5L17.2 3.5L19.5 4.2L17.2 4.9L16.5 6.9L15.8 4.9L13.5 4.2L15.8 3.5L16.5 1.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.5 15.5L4.2 17.5L6.5 18.2L4.2 18.9L3.5 20.9L2.8 18.9L0.5 18.2L2.8 17.5L3.5 15.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 3,
    r: 1,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 16.5,
    r: 0.8,
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.507c58daca56b6c4595239c5409c179f.svg";
export { ForwardRef as ReactComponent };